"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var router_1 = require("next/router");
var link_1 = __importDefault(require("next/link"));
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var useAccordionItem_1 = require("./useAccordionItem");
var styles_1 = require("../../styles");
var LinkAsTitle = styled_components_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  opacity: ", ";\n  text-decoration: none;\n  transition: 200ms opacity ease-in-out;\n  width: 100%;\n\n  ", "\n\n  &:hover {\n    opacity: 1;\n\n    + span {\n      opacity: 1;\n    }\n  }\n"], ["\n  ", "\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  opacity: ", ";\n  text-decoration: none;\n  transition: 200ms opacity ease-in-out;\n  width: 100%;\n\n  ", "\n\n  &:hover {\n    opacity: 1;\n\n    + span {\n      opacity: 1;\n    }\n  }\n"])), (0, styles_1.getP15)(), function (_a) {
    var theme = _a.theme, color = _a.color;
    return theme.colors[color ? color : 'text'];
}, (0, styles_1.getRelative)(20, 'mobile'), function (_a) {
    var color = _a.color, active = _a.active;
    return color || active ? 1 : .4;
}, styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), (0, styles_1.getRelative)(20, 'desktop')));
var Dt = styled_components_1.default.dt(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  transition: 200ms margin-bottom ease-out, 200ms color ease-in-out;\n  width: 100%;\n\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    opacity: 1;\n    /* color: ", "; */\n  }\n\n  > span {\n    opacity: .4;\n  }\n\n  &[aria-expanded='true'] {\n    /* color: ", "; */\n    margin-bottom: ", ";\n    opacity: 1;\n\n    ", "\n\n    > span {\n      opacity: .3;\n    }\n  }\n\n  ", " {\n    margin-bottom: 0;\n\n    ", "\n  }\n"], ["\n  ", "\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  transition: 200ms margin-bottom ease-out, 200ms color ease-in-out;\n  width: 100%;\n\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    opacity: 1;\n    /* color: ", "; */\n  }\n\n  > span {\n    opacity: .4;\n  }\n\n  &[aria-expanded='true'] {\n    /* color: ", "; */\n    margin-bottom: ", ";\n    opacity: 1;\n\n    ", "\n\n    > span {\n      opacity: .3;\n    }\n  }\n\n  ", " {\n    margin-bottom: 0;\n\n    ", "\n  }\n"])), (0, styles_1.getP15)(), function (_a) {
    var theme = _a.theme;
    return (0, styles_1.hex2Rgba)(theme.colors.text, 1);
}, (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), (0, styles_1.getRelative)(20, 'desktop')), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), (0, styles_1.getRelative)(20, 'desktop')), LinkAsTitle, styles_1.mq.greaterThan('tablet')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "]))));
var Dd = (0, styled_components_1.default)(framer_motion_1.motion.dd)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  margin-bottom: ", ";\n  overflow: hidden;\n\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  ", "\n  color: ", ";\n  margin-bottom: ", ";\n  overflow: hidden;\n\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n"])), (0, styles_1.getP15)(), function (_a) {
    var theme = _a.theme;
    return (0, styles_1.hex2Rgba)(theme.colors.text, .4);
}, (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), (0, styles_1.getRelative)(20, 'desktop')));
var Chevron = (0, styled_components_1.default)(framer_motion_1.motion.span)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: inline-block;\n  margin-left: 10px;\n  opacity: .3;\n"], ["\n  display: inline-block;\n  margin-left: 10px;\n  opacity: .3;\n"])));
var transition = {
    ease: [.25, .1, .25, 1],
    duration: .3,
    type: 'tween'
};
var expandVariants = {
    expanded: {
        height: 'auto',
        display: 'block',
        opacity: 1,
        transition: transition
    },
    collapsed: {
        height: 0,
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transition: transition
    },
};
var AccordionItem = function (_a) {
    var data = _a.data, index = _a.index;
    var id = data.id, header = data.header, content = data.content, pathname = data.pathname, color = data.color, onClick = data.onClick, currentSlug = data.currentSlug;
    var _b = __read((0, useAccordionItem_1.useAccordionItem)(index), 7), trigger = _b[0], accordion = _b[1], expanded = _b[2], toggleExpanded = _b[3], onKeyDown = _b[4], setExpanded = _b[6];
    var triggerId = "".concat(id, "__trigger");
    var regionId = "".concat(id, "__region");
    var router = (0, router_1.useRouter)() || { asPath: '', locale: 'es' };
    var _c = __read((0, react_1.useState)(false), 2), active = _c[0], setActive = _c[1];
    (0, react_1.useEffect)(function () {
        if (currentSlug === pathname || router.asPath === pathname || "/category/".concat(router.asPath.split('/')[2]) === pathname) {
            setActive(true);
            if (!expanded)
                toggleExpanded();
        }
        else {
            var _a = __read(pathname.split('/'), 3), cateogry = _a[2];
            var _b = __read(currentSlug.split('/'), 3), _cateogry = _b[2];
            if (cateogry !== _cateogry) {
                setActive(false);
                if (expanded)
                    toggleExpanded();
            }
            else {
                if (active) {
                    setActive(false);
                }
            }
        }
    }, [router.asPath]);
    if (!content && pathname) {
        return ((0, jsx_runtime_1.jsx)(link_1.default, __assign({ href: pathname, locale: router.locale }, { children: (0, jsx_runtime_1.jsx)(LinkAsTitle, __assign({ onClick: onClick ? onClick : null, color: color, active: active }, { children: header })) })));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Dt, __assign({ ref: trigger, id: triggerId, role: 'button', tabIndex: 0, "aria-expanded": expanded, "aria-controls": regionId, onKeyDown: onKeyDown }, { children: [(0, jsx_runtime_1.jsx)(link_1.default, __assign({ href: pathname, locale: router.locale }, { children: (0, jsx_runtime_1.jsx)(LinkAsTitle, __assign({ onClick: function () { setExpanded(true); onClick && onClick(); }, color: color, active: active }, { children: header })) })), (0, jsx_runtime_1.jsx)(Chevron, __assign({ onClick: toggleExpanded, "aria-hidden": true, animate: { rotate: expanded ? 0 : -90 }, transition: transition }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--chevron.svg', alt: 'Icon chevron', width: '6', height: '8' }) }))] })), (0, jsx_runtime_1.jsx)(Dd, __assign({ ref: accordion, role: 'region', id: regionId, "aria-labelledby": triggerId, tabIndex: -1, animate: expanded ? 'expanded' : 'collapsed', initial: 'collapsed', variants: expandVariants }, { children: content }))] }));
};
exports.AccordionItem = AccordionItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
